import { TranslateService } from "@ngx-translate/core";

/**
 * Campos em falta devolvidos pelo servidor (422 `PROPERTY_REQUIRED_FIELDS_INCOMPLETE`,
 * envio para validação, referência definitiva, geração de CMI).
 *
 * O interceptor de HTTP achata a resposta: o que chega pode ser o próprio
 * `{ message, code, missingFields }` ou, sem interceptor, o `HttpErrorResponse`
 * completo — daí olhar para os quatro sítios. Sem lista devolve `[]`.
 */
export function extractMissingFields(err: any): any[] {
  const missing =
    err?.missingFields ??
    err?.message?.missingFields ??
    err?.error?.message?.missingFields ??
    err?.error?.missingFields;
  return Array.isArray(missing) ? missing : [];
}

/**
 * A lista `<ul><li>` para o Swal: a etiqueta já traduzida (`label`) quando o
 * servidor a manda, senão a chave (`labelKey`, com `key` como último recurso).
 */
export function missingFieldsHtml(
  missing: any[],
  translate: TranslateService,
): string {
  const items = (missing ?? [])
    .map((item: any) => {
      const label =
        item?.label ??
        (item?.labelKey
          ? translate.instant(item.labelKey)
          : translate.instant(`${item?.key ?? ""}`));
      return `<li>${label}</li>`;
    })
    .join("");
  return `<ul style="text-align:left;margin:0;padding-left:1.1rem">${items}</ul>`;
}
